import React from 'react';
import { Section, SectionHead } from './primitives';

// Native <details>/<summary> — no state, no handler, no JS. Keeps the route
// prerenderable and working with scripting disabled.
const FAQ = [
  {
    q: 'Is this hosted for us, or do we run it?',
    a: "You run it. The license covers a single-tenant deployment in infrastructure you control. If you'd rather we operate it for you, mention that in your email — managed deployment is available and scoped separately.",
    open: true,
  },
  {
    q: 'Do we get source code?',
    a: "There are container-only and source-included license forms. Which one fits depends on how much you intend to modify and what your security review requires. We'll walk through both.",
  },
  {
    q: 'Can we trade venues other than Hyperliquid?',
    a: 'The execution layer is abstracted behind an adapter interface. Hyperliquid is the venue we ship and support today; additional venues are a scoping conversation.',
  },
  {
    q: 'Does anything report back to Katbot?',
    a: 'No telemetry, no shared control plane, no customer data leaving your account. License validation is handled without transmitting usage or trading data.',
  },
  {
    q: 'What does it cost to run?',
    a: "Your infrastructure and model spend are yours to control directly — research runs are the largest variable, and per-tier model routing exists specifically to manage that. We'll share sizing guidance during the architecture review.",
  },
  {
    q: 'What are the license terms?',
    a: "Term, territory, tenancy, support level, and any exclusivity are set per agreement. Pricing and terms are shared under NDA — email us and we'll start there.",
  },
];

export const LicensingFaq = () => (
  <Section id="faq">
    <SectionHead eyebrow="Questions" title="Before you write to us." />
    <div className="max-w-[80ch]">
      {FAQ.map((item) => (
        <details
          key={item.q}
          open={item.open}
          className="group border-t border-gray-800 py-[18px] first:border-t-0"
        >
          <summary className="flex cursor-pointer list-none items-baseline gap-3.5 text-[1.02rem] font-semibold text-white before:font-mono before:text-[0.95rem] before:text-cyan-400 before:content-['+'] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/60 group-open:before:content-['−'] [&::-webkit-details-marker]:hidden">
            {item.q}
          </summary>
          <p className="mt-2.5 mb-0 max-w-[74ch] pl-7 text-[0.95rem] text-gray-400">{item.a}</p>
        </details>
      ))}
    </div>
  </Section>
);

export default LicensingFaq;
